import { createAction } from '@reduxjs/toolkit';

import { AppSearchParams } from 'utils/url/useAppSearchParams';

const prefix = 'conversationsPage';

export const conversationsActions = {
  setLastSearchParams: createAction<AppSearchParams<'/conversations'>>(
    `${prefix}/setLastSearchParams`,
  ),
};
